module.exports = __webpack_public_path__ + "img/house-night.290665e1.svg";